import { useEffect, useState } from "react";
import { fetchData } from "../function/util";
import ProductList from "../components/ProductList";

const Fabrics=()=>{
    const [data, setData] = useState([]);

    useEffect(()=>{
        fetchData("products", {category:"fabrics"})
        .then((result) => {
            setData(result);
        })
        .catch(() => {
            console.error('Error fetching data:');
        })
    }, []);
    return (
        <div className="main-content">
            <ProductList data={data.products} />
        </div>
    )
}
export default Fabrics;